/* unplugin-vue-components disabled */import script from "./s-model-value-adapter.vue?vue&type=script&setup=true&lang=js"
export * from "./s-model-value-adapter.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__